import Vue from "vue";
import Router from "vue-router";
import store from "./store";
import Home from "./views/Home.vue";
import Login from "./views/Scan.vue";
import Login1 from "./views/Login.vue";
import Redirect from "./views/Redirect.vue";
import { getCompanyServer } from "@/api/index";
let host = window.location.host;
let isTest =
  host.indexOf("qyllb") > -1 ||
  host.indexOf(".test") > -1 ||
  host.indexOf(".beta") > -1 ||
  host.indexOf(".dev") > -1 ||
  host.indexOf("192.168") > -1 ||
  host.indexOf("localhost") > -1;

// ||host.indexOf(".beta") > -1
// host.indexOf("localhost") > -1;

//  ||
Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/login",
      name: "login",
      component: isTest ? Login1 : Login
    },
    {
      path: "/",
      name: "home",
      component: Home,
      children: [
        {
          path: "/homepage",
          name: "HomePage"
        },
        {
          path: "/redirect",
          name: "redirect",
          component: Redirect
        },
        // 服务器设置
        // 服务器/FTP维护
        {
          path: "/server-setting/server-ftp-maintenance",
          name: "serverSettingServerFTPMaintenance",
          component: () =>
            import(/*webpackChunkName:"serverSetting" */ "@/views/serverSetting/ServerFTPMaintenance.vue"),
          meta: { title: "服务器/FTP维护" }
        },

        // 直连插件管理
        // 直连经销商管理
        {
          path: "/direct-manage/direct-dealer-manage",
          name: "serverSettingDirectDealerManage",
          component: () =>
            import(/*webpackChunkName:"directManage" */ "@/views/directManage/DirectDealerManage.vue"),
          meta: { title: "直连经销商管理" }
        },
        // 期间设置
        {
          path: "/direct-manage/period-set",
          name: "directManagePeriodSet",
          component: () =>
            import(/*webpackChunkName:"directManage" */ "@/views/directManage/PeriodSet.vue"),
          meta: { title: "期间设置" }
        },
        // 临时抓取任务
        {
          path: "/direct-manage/temp-snatch-task",
          name: "directManageTempSnatchTask",
          component: () =>
            import(/*webpackChunkName:"directManage" */ "@/views/directManage/TempSnatchTask.vue"),
          meta: { title: "临时抓取任务" }
        },
        {
          path: "/direct-manage/batch-import-task",
          name: "directManageBatchImportTask",
          component: () =>
            import(/*webpackChunkName:"originalFile" */ "@/views/directManage/BatchImportTask.vue"),
          meta: {
            title: "批量导入任务",
            breadcrumb: [
              {
                title: "临时抓取任务 ",
                name: "directManageTempSnatchTask"
              }
            ]
          }
        },
        // 新建任务
        {
          path: "/direct-manage/new-task",
          name: "directManageNewTask",
          component: () =>
            import(/*webpackChunkName:"directManage" */ "@/views/directManage/NewTask.vue"),
          meta: { title: "SQL新增任务" }
        },
        // 文件拆分管理
        {
          path: "/direct-manage/file-split",
          name: "directManageFileSplit",
          component: () =>
            import(/*webpackChunkName:"directManage" */ "@/views/directManage/FileSplit.vue"),
          meta: { title: "文件拆分管理" }
        },
        // 拆分设置
        {
          path: "/direct-manage/split-set/:id",
          name: "directManageSplitSet",
          component: () =>
            import(/*webpackChunkName:"directManage" */ "@/views/directManage/SplitSet.vue"),
          meta: { title: "拆分设置" }
        },

        // 网站抓取管理
        // 直连网站管理
        {
          path: "/web-grasp-manage/direct-web-manage",
          name: "webGraspManageDirectWebManage",
          component: () =>
            import(/*webpackChunkName:"webGraspManage" */ "@/views/webGraspManage/directWebManage.vue"),
          meta: { title: "直连网站管理" }
        },
        // 设置账号
        {
          path: "/web-grasp-manage/set-account",
          name: "webGraspManageSetAccount",
          component: () =>
            import(/*webpackChunkName:"webGraspManage" */ "@/views/webGraspManage/setAccount.vue"),
          meta: { title: "设置账号" }
        },
        // 直连网站管理 - 期间设置
        {
          path: "/web-grasp-manage/web-period-set/:scrap_type",
          name: "webGraspManageWebPeriodSet",
          component: () =>
            import(/*webpackChunkName:"webGraspManage" */ "@/views/webGraspManage/webPeriodSet.vue"),
          meta: { title: "期间设置" }
        },
        // 网站抓取管理 文件拆分管理
        {
          path: "/web-grasp-manage/file-split/:scrap_type",
          name: "webGraspManageFileSplit",
          component: () =>
            import(/*webpackChunkName:"directManage" */ "@/views/webGraspManage/FileSplit.vue"),
          meta: { title: "文件拆分管理" }
        },
        // 网站抓取管理 拆分设置
        {
          path: "/web-grasp-manage/split-set/:id/:scrap_type",
          name: "webGraspManageSplitSet",
          component: () =>
            import(/*webpackChunkName:"directManage" */ "@/views/webGraspManage/SplitSet.vue"),
          meta: { title: "拆分设置" }
        },
        // 监控管理
        // 直连插件监控器
        {
          path: "/monitoring-manage/plug-in-monitoring",
          name: "monitoringManageplugInMonitoring",
          component: () =>
            import(/*webpackChunkName:"monitoringManage" */ "@/views/monitoringManage/plugInMonitoring.vue"),
          meta: { title: "直连插件监控器" }
        },
        // 插件监控器 --> 查看日志
        {
          path:
            "/monitoring-manage/view-log/:plugin_code/:client_code/:client_name",
          name: "monitoringManageViewLog",
          component: () =>
            import(/*webpackChunkName:"monitoringManageViewLog" */ "@/views/monitoringManage/viewLog.vue"),
          meta: {
            title: "查看日志",
            breadcrumb: [
              {
                title: "直连插件监控器",
                name: "monitoringManageplugInMonitoring"
              }
            ]
          }
        },
        // 插件监控器 --> 查看SQL
        {
          path: "/monitoring-manage/remote-sql/:plugin_code/:client_code",
          name: "monitoringManageRemoteSql",
          component: () => import("@/views/monitoringManage/remoteSql.vue"),
          meta: {
            title: "查看SQL",
            breadcrumb: [
              {
                title: "直连插件监控器",
                name: "monitoringManageplugInMonitoring"
              }
            ]
          }
        },
        // 网站抓取监控
        {
          path: "/monitoring-manage/web-period-monitoring",
          name: "monitoringManageWebPeriodMonitoring",
          component: () =>
            import(/*webpackChunkName:"monitoringManage" */ "@/views/monitoringManage/WebPeriodMonitoring.vue"),
          meta: { title: "网站抓取监控" }
        },
        // 网站抓取监控
        {
          path: "/monitoring-manage/new-web-period-monitoring",
          name: "monitoringManageNewWebPeriodMonitoring",
          component: () =>
            import(/*webpackChunkName:"monitoringManage" */ "@/views/monitoringManage/newWebPeriodMonitoring.vue"),
          meta: { title: "网站抓取监控（新）" }
        },
        // 原始文件管理
        // 直连文件查询
        {
          path: "/original-file/up-file-inquire/:type",
          name: "originalFileUpFileInquire",
          component: () =>
            import(/*webpackChunkName:"originalFile" */ "@/views/originalFile/upFileInquire.vue"),
          meta: { title: "直连文件查询" }
        },
        // 网抓文件查询-
        {
          path: "/original-file/web-scrap",
          name: "originalFileWebScrap",
          component: () =>
            import(/*webpackChunkName:"originalFile" */ "@/views/originalFile/WebScrap.vue"),
          meta: { title: "网抓文件查询" }
        },
        // 网抓门店文件查询
        {
          path: "/original-file/web-scrap-store",
          name: "originalFileWebScrap",
          component: () =>
            import(/*webpackChunkName:"originalFile" */ "@/views/originalFile/WebScrapStore.vue"),
          meta: { title: "网抓门店文件查询" }
        },
        // 邮件抓取管理  商业映射管理
        {
          path: "/mail-fetching/business-mapping",
          name: "mailFetchingBusinessMapping",
          component: () =>
            import(/*webpackChunkName:"originalFile" */ "@/views/mailFetching/BusinessMapping.vue"),
          meta: { title: "商业映射管理" }
        },
        // 邮件抓取管理  商业映射管理  批量操作
        {
          path: "/mail-fetching/batch-operation",
          name: "mailFetchingBatchOperation",
          component: () =>
            import(/*webpackChunkName:"originalFile" */ "@/views/mailFetching/BatchOperation.vue"),
          meta: {
            title: "批量操作",
            breadcrumb: [
              {
                title: "商业映射管理",
                name: "mailFetchingBusinessMapping"
              }
            ]
          }
        },
        // 监控管理  邮件抓取管理
        {
          path: "/monitoring-manage/mail-fetching-manage",
          name: "monitoringManageMailFetchingManage",
          component: () =>
            import(/*webpackChunkName:"monitoringManage" */ "@/views/monitoringManage/MailFetchingManage.vue"),
          meta: { title: "邮件抓取管理" }
        },
        // 编辑产品维护
        {
          path: "/ddiManage/system-set",
          name: "systemSet",
          component: () =>
            import(/*webpackChunkName:"systemSet" */ "./views/systemSet/systemSet.vue"),
          meta: { title: "系统设置" }
        },
        // 系统设置-操作日志
        {
          path: "/system-set/operation-log",
          name: "systemSetOperationlog",
          component: () =>
            import(/*webpackChunkName:"systemSet" */ "./views/systemSet/OperationLog.vue"),
          meta: { title: "系统设置" }
        },
        // 系统设置-操作日志
        {
          path: "/system-set/capture-log",
          name: "systemSetCaptureLog",
          component: () =>
            import(/*webpackChunkName:"systemSet" */ "./views/capture-log.vue"),
          meta: { title: "系统设置" }
        },
        {
          path: "/ddiManage/date-filtering",
          name: "DateFiltering",
          component: () => import("./views/systemSet/DateFiltering.vue"),
          meta: {
            title: "FTP日期过滤",
            breadcrumb: [
              {
                title: "系统设置",
                name: "systemSet"
              }
            ]
          }
        },
        // ftp 文件拆分
        {
          path: "/ftpCapture/FileSplit",
          name: "ftpCaptureFileSplit",
          component: () =>
            import(/*webpackChunkName:"ftpCapture" */ "./views/ftpCapture/FileSplit.vue"),
          meta: { title: "文件拆分管理" }
        },
        // ftp 拆分设置
        {
          path: "/ftpCapture/split-set/:id",
          name: "ftpCaptureSplitSet",
          component: () =>
            import(/*webpackChunkName:"directManage" */ "@/views/ftpCapture/SplitSet.vue"),
          meta: { title: "拆分设置" }
        },
        // 网站爬虫管理 初始化数据
        {
          path: "/web-grasp-manage/Initialization-data",
          name: "webGraspManageInitializationData",
          component: () =>
            import(/*webpackChunkName:"directManage" */ "@/views/webGraspManage/InitializationData.vue"),
          meta: { title: "初始化数据" }
        },
        // 网站爬虫管理 历史月数据采集
        {
          path: "/web-grasp-manage/history_reriod_month",
          name: "webGraspManageHistoryReriodMonth",
          component: () =>
            import(/*webpackChunkName:"directManage" */ "@/views/webGraspManage/HistoryReriodMonth.vue"),
          meta: { title: "历史月数据采集" }
        },
        // 网站爬虫管理 多账号网站
        {
          path: "/web-grasp-manage/multi-account-website/index",
          name: "webGraspManageMultiAccountWebsiteIndex",
          component: () =>
            import(/*webpackChunkName:"directManage" */ "@/views/webGraspManage/multiAccountWebsite/index.vue"),
          meta: { title: "多账号网站" }
        },
        // 网站爬虫管理 多账号网站  查看数据
        {
          path: "/web-grasp-manage/multi-account-website/list/:web_scrap_id",
          name: "webGraspManageMultiAccountWebsiteList",
          component: () =>
            import(/*webpackChunkName:"originalFile" */ "@/views/webGraspManage/multiAccountWebsite/list.vue"),
          meta: {
            title: "查看数据",
            breadcrumb: [
              {
                title: "多账号网站",
                name: "webGraspManageMultiAccountWebsiteIndex"
              }
            ]
          }
        },
        // 网站爬虫管理 多账号网站  查看数据
        {
          path:
            "/web-grasp-manage/multi-account-website/details/:web_scrap_log_id/:data_type/:web_scrap_id",
          name: "webGraspManageMultiAccountWebsiteDetails",
          component: () =>
            import(/*webpackChunkName:"originalFile" */ "@/views/webGraspManage/multiAccountWebsite/details.vue"),
          meta: {
            title: "查看数据",
            breadcrumb: [
              {
                title: "多账号网站",
                name: "webGraspManageMultiAccountWebsiteIndex"
              }
            ]
          }
        }
      ]
    },
    {
      path: "*",
      name: "404",
      redirect: { name: "home" }
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (
    (to.name === "home" || store.state.isPrivate === -1) &&
    to.name !== "login"
  ) {
    getCompanyServer().then(res => {
      if (0 === res.status) {
        const isPrivate = res.data.is_private;
        store.commit("setIsPrivate", isPrivate);
        if (to.name === "home") {
          if (isPrivate === 0) {
            // router.push({ name: "serverSettingDirectDealerManage" });
            router.push({ name: "HomePage" });
          } else {
            // router.push({ name: "serverSettingServerFTPMaintenance" });
            router.push({ name: "HomePage" });
          }
        } else {
          next();
        }
      } else {
        if (to.name === "home") {
          router.push({ name: "serverSettingServerFTPMaintenance" });
        } else {
          next();
        }
      }
    });
  } else {
    next();
  }
});

router.beforeEach((to, from, next) => {
  if (to.name === from.name) {
    next({ name: "redirect", query: { toPath: to.fullPath } });
  } else {
    next();
  }
});

router.afterEach((to, form) => {
  const path = to.path;
  store.commit("setCurrentUrl", path);
});
export default router;
